import React from "react";
import Modal from "../../Layout/Modal";

const ModalImageDesc = ({
  modalId,
  onCloseModal,
  filesDescs,
  fileSelected,
  media_types,
  content_types,
  onAddFileDescModal,
  onDescChange,
}) => {
  return (
    <Modal
      id={modalId}
      title="Image Description"
      onClose={onCloseModal}
      modalSize="modal-lg"
    >
      <div className="col-md-12">
        <div className="form-group">
          <label htmlFor="file_name">Image Name</label>
          <input
            name="file_name"
            value={fileSelected.fileName || fileSelected.file_name}
            className="form-control"
            disabled={true}
          />
        </div>
      </div>

      <div className="col-md-12">
        <div className="form-group">
          <label htmlFor="description">Image Description</label>
          {filesDescs[fileSelected.fileName || fileSelected.file_name] ? (
            <input
              type="text"
              name="description"
              value={
                filesDescs[fileSelected.fileName || fileSelected.file_name]
                  .media_desc
              }
              onChange={onDescChange}
              className="form-control"
            />
          ) : (
            <input
              type="text"
              name="description"
              value=""
              onChange={onDescChange}
              className="form-control"
            />
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="media_types">Image Type</label>
            {media_types.length > 0 &&
              media_types.map((item) => (
                <div
                  key={item.code}
                  onClick={() => onAddFileDescModal(item.code, "media_types")}
                  className={
                    filesDescs[
                      fileSelected.fileName || fileSelected.file_name
                    ] &&
                    filesDescs[
                      fileSelected.fileName || fileSelected.file_name
                    ].media_types.indexOf(item.code) > -1
                      ? "bg-orange"
                      : "bg-white"
                  }
                  style={{
                    border: "1px solid #ccc",
                    marginBottom: 5,
                    padding: 5,
                    borderRadius: 5,
                    cursor: "pointer",
                  }}
                >
                  {item.name}
                </div>
              ))}
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="content_types">Content Type</label>
            {content_types.length > 0 &&
              content_types.map((item) => (
                <div
                  key={item.code}
                  onClick={() => onAddFileDescModal(item.code, "content_types")}
                  className={
                    filesDescs[
                      fileSelected.fileName || fileSelected.file_name
                    ] &&
                    filesDescs[
                      fileSelected.fileName || fileSelected.file_name
                    ].content_types.indexOf(item.code) > -1
                      ? "bg-orange"
                      : "bg-white"
                  }
                  style={{
                    border: "1px solid #ccc",
                    marginBottom: 5,
                    padding: 5,
                    borderRadius: 5,
                    cursor: "pointer",
                  }}
                >
                  {item.name}
                </div>
              ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalImageDesc;
